import { ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const SOURCES = ["Destination data", "Product catalogue", "Pricing", "Packages", "Media", "Content"];
const NOW = ["Website", "Quotes", "Enquiries", "Agent channels"];
const LATER = ["Distribution APIs"];

export default function ConfigureOnce() {
  return (
    <section className="py-24 lg:py-32">
      <div className="container-x">
        <Reveal><Chapter index={9} label="Distribution Model" /></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-8 max-w-2xl font-serif text-3xl leading-[1.15] tracking-tight text-ink sm:text-4xl lg:text-5xl">
            Configure Once. Publish Everywhere.
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-stone2">
            Your destination data becomes the foundation for every sales and
            distribution channel — set it up once, use it everywhere.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-12 grid grid-cols-1 items-stretch gap-4 rounded-2xl border border-sand bg-white p-6 sm:p-8 lg:grid-cols-[1fr_auto_1fr]" data-testid="configure-once-diagram">
            <div className="space-y-2">
              <p className="mb-3 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-stone2">You configure</p>
              {SOURCES.map((s) => (
                <div key={s} className="rounded-xl border border-sand bg-paper px-4 py-3 text-sm font-semibold text-ink" data-testid={`configure-source-${s.toLowerCase().replace(/\s/g, "-")}`}>
                  {s}
                </div>
              ))}
            </div>
            <div className="flex items-center justify-center lg:flex-col">
              <div className="flex flex-col items-center gap-2 rounded-2xl bg-ink px-6 py-5 text-center lg:my-auto">
                <span className="font-serif text-lg text-paper">Travel-Tek</span>
                <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-terra">one source of truth</span>
                <ArrowRight className="hidden h-4 w-4 rotate-0 text-terra lg:block" />
                <ArrowRight className="h-4 w-4 rotate-90 text-terra lg:hidden" />
              </div>
            </div>
            <div className="space-y-2">
              <p className="mb-3 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-stone2">It powers</p>
              {NOW.map((c) => (
                <div key={c} className="flex items-center justify-between rounded-xl border border-sand bg-paper px-4 py-3" data-testid={`configure-channel-${c.toLowerCase().replace(/\s/g, "-")}`}>
                  <span className="text-sm font-semibold text-ink">{c}</span>
                  <span className="rounded-full bg-emerald2/10 px-2 py-0.5 font-mono text-[9px] font-bold uppercase tracking-wider text-emerald2">Available now</span>
                </div>
              ))}
              {LATER.map((c) => (
                <div key={c} className="flex items-center justify-between rounded-xl border border-dashed border-terra/60 bg-terra/5 px-4 py-3" data-testid="configure-channel-apis">
                  <span className="text-sm font-semibold text-stone2">{c}</span>
                  <span className="rounded-full bg-terra/15 px-2 py-0.5 font-mono text-[9px] font-bold uppercase tracking-wider text-terra">Built for expansion</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
